/* RESPONSIBLE TEAM: team-ai-agent-2 */

export interface AiAgentIdentityWireFormat {
  name: string;
  is_default: boolean;
  avatar: {
    image_urls: {
      square_25: string;
      square_50: string;
      square_128: string;
    };
    type: 'custom' | 'default';
  };
}

interface ImageUrls {
  square25: string;
  square50: string;
  square128: string;
}

export interface Avatar {
  imageUrl: ImageUrls;
  type: 'custom' | 'default';
}

export default class AiAgentIdentity {
  readonly name: string;
  readonly isDefault: boolean;
  readonly avatar: Avatar;

  constructor(name: string, isDefault: boolean, avatar: Avatar) {
    this.name = name;
    this.isDefault = isDefault;
    this.avatar = avatar;
  }

  get initials(): string {
    return this.name
      .split(' ')
      .map((part) => part[0])
      .join('');
  }

  get shape(): string {
    return 'squircle';
  }

  get imageUrl(): string {
    return this.avatar.imageUrl.square128;
  }

  static deserialize(json: AiAgentIdentityWireFormat): AiAgentIdentity {
    return new AiAgentIdentity(json.name, json.is_default, {
      imageUrl: {
        square25: json.avatar.image_urls.square_25,
        square50: json.avatar.image_urls.square_50,
        square128: json.avatar.image_urls.square_128,
      },
      type: json.avatar.type,
    });
  }
}
